// IMPORTANT: this file (and imported here) should have .js extension, because it should work in IE

var isBrowserSupported = require("./utils").isBrowserSupported

if (!isBrowserSupported()) {
  window.location.href = "/fallback"
}
